import { useRouter } from 'next/router'
import {
  AuthConfigNanoIdSchema,
  ConnectedAccountNanoIdSchema,
} from '@composio/types'

import type { GetConnectedAccountsData } from '~/generated/client'

export const useRouterParsed = () => {
  const router = useRouter()
  const { query } = router

  const authConfigId =
    'connectorId' in query
      ? AuthConfigNanoIdSchema.parse(query.connectorId)
      : undefined

  const connectedAccountId =
    'connectionId' in query
      ? ConnectedAccountNanoIdSchema.parse(query.connectionId)
      : undefined

  const page = 'page' in query ? Number(query.page) : undefined

  const status =
    'status' in query
      ? (query.status as NonNullable<
          GetConnectedAccountsData['statuses']
        >[number])
      : undefined

  const showDisabled =
    'showDisabled' in query ? query.showDisabled === 'true' : undefined

  const entityId =
    'entityId' in query && typeof query.entityId === 'string'
      ? query.entityId
      : undefined

  const usecase =
    'usecase' in query && typeof query.usecase === 'string'
      ? query.usecase
      : undefined

  const tag =
    'tag' in query && typeof query.tag === 'string' ? query.tag : undefined

  const routerReady = router.isReady

  return {
    authConfigId,
    page,
    status,
    showDisabled,
    entityId,
    query,
    router,
    connectedAccountId,
    usecase,
    routerReady,
    tag,
    /**
     * @deprecated use connectedAccountId instead
     */
    connectorId: authConfigId,
    /**
     * @deprecated use connectedAccountId instead
     */
    connectionId: connectedAccountId,
  }
}
